// Données des projets avec des ratios plus appropriés
const projects = [
    {
        id: 1,
        name: "Yolo",
        title: "Yolo – Plateforme de Fidélisation Commerciale",
        description:
            "Site web de présentation d'un programme de fidélité destiné aux entreprises. Il permet de créer une carte de fidélité digitale, de suivre les statistiques clients, d'envoyer des notifications marketing, et d'optimiser les économies grâce à la fidélisation. Le site adopte un ton accrocheur avec un design sombre et contrasté, mettant en avant les bénéfices pour les commerçants.",
        category: "Site web - SaaS / Marketing et fidélisation client",
        image: "/images/1.png", // Chemin corrigé pour pointer vers public/images
        tags: ["React", "Node.js", "Stripe"],
        link: "#",
        color: "#D4A373",
        gridArea: "1 / 1 / 2 / 3", // row-start/col-start/row-end/col-end
        ratio: {
            desktop: "2.5/1", // Format panoramique plus large
            mobile: "1/1", // Format légèrement horizontal sur mobile
        },
    },
    {
        id: 2,
        name: "LocalLink",
        title: "Application de Mise en Relation Locale",
        description:
            "Interface mobile dynamique permettant la mise en relation entre utilisateurs pour des services ou rendez-vous de proximité. Elle inclut des profils utilisateurs, des cartes de localisation, des évaluations, une messagerie et la gestion d'offres ou de demandes de services. Le design est moderne, coloré et orienté vers l'interaction sociale.",
        category: "Application mobile - Réseautage / Services de proximité",
        image: "/images/2.png",
        tags: ["Angular", "Firebase", "Chart.js"],
        link: "#",
        color: "#22c55e",
        gridArea: "1 / 3 / 3 / 4",
        ratio: {
            desktop: "1/1.2", // Presque carré, légèrement vertical
            mobile: "1/1", // Carré parfait sur mobile
        },
    },
    {
        id: 3,
        name: "Sen'do Sushi",
        title: "Sen'do Sushi - Application de Commande",
        description:
            "Application mobile élégante pour la commande de sushi, avec une interface sombre et épurée. Elle permet la personnalisation des commandes, la sélection des accompagnements (soupe miso), et offre une expérience utilisateur fluide avec un système de panier et de validation intuitif.",
        category: "Application Mobile - Restauration",
        image: "/images/3.png",
        tags: ["React Native", "Node.js", "MongoDB"],
        link: "#",
        color: "#2A9D8F",
        gridArea: "2 / 1 / 3 / 2",
        ratio: {
            desktop: "1/1", // Format carré
            mobile: "1/1", // Légèrement vertical sur mobile
        },
    },
    {
        id: 4,
        name: "Uman",
        title: "Uman - Téléconsultation Médicale",
        description:
            "Application de téléconsultation médicale permettant aux professionnels de santé de réaliser des consultations à distance. Intègre des fonctionnalités d'appel vidéo, messagerie instantanée, partage de documents médicaux, et gestion de rendez-vous. Interface intuitive avec une expérience utilisateur optimisée pour patients et praticiens.",
        category: "Application Mobile - Santé",
        image: "/images/4.png",
        tags: ["Vue.js", "Express", "D3.js"],
        link: "#",
        color: "#E76F51",
        gridArea: "2 / 2 / 3 / 3",
        ratio: {
            desktop: "16/9",
            mobile: "1/1",
        },
    },
    {
        id: 5,
        name: "Conseil Voyage",
        title: "Conseil Voyage - Agence de Voyages en Ligne",
        description:
            "Site web élégant d'une agence de voyages offrant un processus de réservation simplifié en plusieurs étapes. Design moderne avec palette de couleurs apaisante, présentant des destinations de rêve comme Florence, plages tropicales et expériences aériennes. Inclut un formulaire de recherche intuitif et une présentation claire des services.",
        category: "Site Web - Tourisme et Voyages",
        image: "/images/5.png",
        tags: ["Three.js", "GSAP", "React"],
        link: "#",
        color: "#8338EC",
        gridArea: "3 / 1 / 4 / 2",
        ratio: {
            desktop: "16/9",
            mobile: "1/1",
        },
    },
    {
        id: 6,
        name: "L'heure du sport",
        title: "L'heure du sport - Coaching Fitness en Ligne",
        description:
            "Site web complet pour coach sportif proposant des programmes d'entraînement personnalisés. Design dynamique avec palette orange et blanc, présentant les avantages du coaching, témoignages clients et différentes formules d'abonnement. Inclut un formulaire de contact et une mise en page structurée qui valorise la transformation physique des clients.",
        category: "Site Web - Sport et Bien-être",
        image: "/images/6.png",
        tags: ["React", "IoT", "WebSockets"],
        link: "#",
        color: "#3A86FF",
        gridArea: "3 / 2 / 4 / 4",
        ratio: {
            desktop: "16/9",
            mobile: "1/1",
        },
    },
];

// Patterns d'animation pour chaque projet
const projectPatterns = {
    1: { scale: 1.1, speed: 0.8, turbulence: 0.3, rotation: [0.1, 0.05, 0.02] },
    2: { scale: 0.9, speed: 1.2, turbulence: 0.5, rotation: [0.05, 0.1, 0.05] },
    3: {
        scale: 1.0,
        speed: 0.7,
        turbulence: 0.4,
        rotation: [0.02, 0.03, 0.08],
    },
    4: {
        scale: 1.2,
        speed: 1.0,
        turbulence: 0.2,
        rotation: [0.08, 0.02, 0.03],
    },
    5: {
        scale: 0.8,
        speed: 1.3,
        turbulence: 0.6,
        rotation: [0.03, 0.07, 0.04],
    },
    6: {
        scale: 1.3,
        speed: 0.6,
        turbulence: 0.7,
        rotation: [0.04, 0.06, 0.01],
    },
};

// Fonction utilitaire pour obtenir le pattern d'un projet
const getProjectPattern = (id) => {
    return projectPatterns[id] || projectPatterns[1];
};

export { projects, getProjectPattern };
